import MobileStaff from '@square/dashboard-data/models/squareup/beemo/api/v2/models/mobile-staff';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Employee from '@square/dashboard-data/models/squareup/beemo/api/v2/models/employee';

// Only one of these fields will be set.
export default ProtoBaseModel.extend({
  // Optionally set for mobile staff created tenders.
  mobileStaff: attr(MobileStaff),
  // Optionally set for the employee creator
  employee: attr(Employee)
});